const rootClassName = 'collapsible',
  chevronClassName = 'content-clicker__icon',
  chevronClosedClassName = 'icon-aesthetics--plus',
  chevronOpenClassName = 'icon-aesthetics--minus',
  labelClassName = 'collapsible__label',
  labelOpenClassName = `${labelClassName}--open`

// Showing and hiding the panel itself is done by <details>, so this only
// syncs the plus/minus icon and label styling. That way the accordion still
// opens and closes without JavaScript.

function showCollapsible(rootElement: HTMLDetailsElement) {
  rootElement.querySelector(`.${chevronClassName}`)?.classList.add(chevronOpenClassName)
  rootElement.querySelector(`.${chevronClassName}`)?.classList.remove(chevronClosedClassName)
  rootElement.querySelector(`.${labelClassName}`)?.classList.add(labelOpenClassName)
}

function hideCollapsible(rootElement: HTMLDetailsElement) {
  rootElement.querySelector(`.${chevronClassName}`)?.classList.remove(chevronOpenClassName)
  rootElement.querySelector(`.${chevronClassName}`)?.classList.add(chevronClosedClassName)
  rootElement.querySelector(`.${labelClassName}`)?.classList.remove(labelOpenClassName)
}

function InitCollapsible() {
  Array.from(document.getElementsByClassName(rootClassName)).forEach(collapsibleElement => {
    if (!(collapsibleElement instanceof HTMLDetailsElement)) {
      return
    }

    collapsibleElement.addEventListener('toggle', () => {
      if (collapsibleElement.open) {
        showCollapsible(collapsibleElement)
      } else {
        hideCollapsible(collapsibleElement)
      }
    })
  })
}

InitCollapsible()
